<ng-template cdkPortal #actions="cdkPortal">
  <a class="btn btn-icon btn-secondary"
     [routerLink]="createPath"
     [queryParams]="query.filters">
    <icon-plus></icon-plus>
    <span class="ml-2">Add moderator</span>
  </a>
</ng-template>
<smart-table [headers]="headers"
             [source]="source"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [collapseAuto]="false"
             [collapseByClick]="true"
             (collapsedChange)="initForm($event)"
             [navigate]="editPath">
  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.id }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="name" let-item>
    <td>
      {{ item.firstName }} {{ item.secondName }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="email" let-item>
    <td>
      {{ item.email }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="active" let-item>
    <td>
      <badge-exist existText="Active" [item]="item.active"></badge-exist>
    </td>
  </ng-template>


  <ng-template smartTableCollapse let-item let-index="index" let-collapse="collapse">
    <form [formGroup]="forms[item.id]" (ngSubmit)="save(item, index)">
      <div class="row">
        <div class="col-60">
          <div class="form-group">
            <label>E-mail</label>
            <form-group-simple name="email" placeholder="Email" formControlName="email"></form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-30">
          <div class="form-group">
            <label>First name</label>
            <form-group-simple name="firstName" placeholder="First Name" formControlName="firstName"></form-group-simple>
          </div>
        </div>
        <div class="col-30">
          <div class="form-group">
            <label>Second name</label>
            <form-group-simple name="secondName" placeholder="Second Name" formControlName="secondName"></form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-30">
          <div class="form-group">
            <label>Password</label>
            <form-group-simple name="password" inputType="password" placeholder="Password" formControlName="password"></form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col form-group form-inline">
          <span class="mr-5">
            <form-group-simple type="checkbox" name="active" formControlName="active">Active</form-group-simple>
          </span>
          <span class="mr-5">
            <form-group-simple type="checkbox" name="admin" formControlName="admin">Admin</form-group-simple>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-auto">
<!--          <btn-delete form actions type="moderator"-->
<!--                      [name]="item.name"-->
<!--                      (delete)="delete($event, item.id)">-->
<!--          </btn-delete>-->
        </div>
        <div class="col-auto ml-auto">
          <div class="m-n2">
            <button class="btn btn-success m-2" type="submit" [disabled]="forms[item.id].disabled">
              Save
            </button>
            <button class="btn btn-outline-info m-2" type="button"
                    (click)="cancel(collapse)">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>

